import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonHttpService } from '../../../shared/services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { OauthService } from '../../../shared/services/oauth.service';
import { ClientModel } from '../../../shared/models/client.model';

@Component({
    selector: 'account-profile-extra-fields',
    templateUrl: './account.profile.extra-fields.component.html'
})
export class AccountProfileExtraFieldsComponent {
    @Input('client') client;

    public updating = false;
    public updated = {};
    public extraFields = [];

    constructor(
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService,
        protected oauthService: OauthService
    ) {
        this.oauthService.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.extraFields = this.extractsExtraFields();
        });
    }

    public dataUpdated(data) {
        this.updated[data.key] = data.value;
    }
    public save() {
        this.translate.get([
            'ACCOUNT.PROFILE.BOXES.ADDITIONAL_DATA.UPDATE.SUCCESS',
            'ACCOUNT.PROFILE.BOXES.ADDITIONAL_DATA.UPDATE.ERROR'
        ]).subscribe(translated => {
            this.http
            .useAuth()
            .put(`/account/clients/${this.client.id}`, this.updated)
            .subscribe(() => {
                this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.ADDITIONAL_DATA.UPDATE.SUCCESS']);
                this.updating = false;
                this.oauthService.init();
            }, () => {
                this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.ADDITIONAL_DATA.UPDATE.ERROR']);
                this.updating = false;
            });
        });
    }

    private extractsExtraFields() {
        const extraFields = [];
        for (const field in this.client) {
            if (this.isExtraField(field)) {
                extraFields.push({'value': this.client[field], 'key': field});
            }
        }
        return extraFields;
    }
    private isExtraField(fieldName) {
        return this.client.hasOwnProperty(fieldName)
            && /[a-zA-Z]{1,}\_[0-9]{1,}\_[0-9]{1,}/.test(fieldName);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/profile/extra-fields/account.profile.extra-fields.component.ts